<div [class.login-page]="isLoginPage()">
    @if (isLoading()) {
        <app-dot-animation [isLoading]="isLoading()"></app-dot-animation>
    }
    @if (!isLoginPage()) {
        <app-top-nav></app-top-nav>
    }
    <div class="fixed top-6 z-50 w-full max-w-sm sm:right-40 flex flex-col gap-4">
        @for (notification of notifications(); track notification.id) {
            <app-notification-alert
                    [type]="notification.type"
                    [message]="notification.message"
                    [isLeaving]="notification.isLeaving"
                    (close)="notificationService.startLeaveAnimation(notification.id)"
                    class="transform transition-all duration-500 ease-in-out">
            </app-notification-alert>
        }
    </div>
    <router-outlet></router-outlet>
</div>